import { render, staticRenderFns } from "./MindHistoryView.vue?vue&type=template&id=41d0d272&scoped=true"
import script from "./MindHistoryView.vue?vue&type=script&lang=js"
export * from "./MindHistoryView.vue?vue&type=script&lang=js"
import style0 from "./MindHistoryView.vue?vue&type=style&index=0&id=41d0d272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d0d272",
  null
  
)

export default component.exports